import React from 'react';

const TutorialPhase = ({onComplete}) => {
  return (
    <div className="lcv-tutorial-overlay">
      <div className="lcv-tutorial-box">
        <div className="lcv-tutorial-video">
          <div className="lcv-tutorial-play">▶</div>
          <span style={{color: 'rgba(255,255,255,0.4)', fontSize: 13}}>Tutorial Video Placeholder</span>
        </div>
        <h2 className="lcv-tutorial-title">Welcome to Your Lesson!</h2>
        <p className="lcv-tutorial-sub">
          Watch this quick tutorial to learn how your AI-powered lesson works.
          You'll meet your tutor, learn about the workbook, and see how to ace the mastery test.
        </p>
        <button className="lcv-btn-primary" style={{marginTop: 20}} onClick={onComplete}>
          Let's Begin!
        </button>
      </div>
    </div>
  );
};

export default TutorialPhase;
